import { useCallback, useMemo } from 'react';
import { useForm } from '@/js/libs/final-form';
import { useFieldValue } from './useFieldValue';
export const useFieldState = (fieldName) => {
    const { change } = useForm();
    const fieldValue = useFieldValue(fieldName);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const setValue = useCallback((newValue) => change(fieldName, newValue), [change, fieldName]);
    return useMemo(() => [fieldValue, setValue], [fieldValue, setValue]);
};
